"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContext = void 0;
exports.ToastProvider = ToastProvider;
exports.useToastContext = useToastContext;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
exports.ToastContext = (0, react_1.createContext)({
    setNotice: () => {
        throw new Error("Missing ToastProvider");
    },
    clear: () => { },
    notice: undefined,
});
function ToastProvider(props) {
    const [notice, setNotice] = (0, react_1.useState)();
    const clear = (0, react_1.useCallback)(() => setNotice(undefined), [setNotice]);
    const contextValue = (0, react_1.useMemo)(() => ({ setNotice, notice, clear }), [notice, clear]);
    return (0, jsx_runtime_1.jsx)(exports.ToastContext.Provider, { value: contextValue, children: props.children });
}
function useToastContext() {
    return (0, react_1.useContext)(exports.ToastContext);
}
